import { useQuery } from "@tanstack/react-query";

import { indexAffinity } from "app/pages/sales-intelligence/domain/industry/utils/affinitySuggestions";

import { createAffinityQuery } from "./options";

type UseIndustryAffinityQueryOptions = {
    enabled?: boolean;
};

export default function useIndustryAffinityQuery({ enabled = true }: UseIndustryAffinityQueryOptions = {}) {
    // `indexAffinity` is module-level, so react-query memoizes the indexed result across renders.
    return useQuery(createAffinityQuery({ select: indexAffinity, enabled }));
}
